<template>
  <div class="center-map">
    <centerTop></centerTop>
    <mapTop v-if="mapListData.pointInfoList" :pointInfo="pointInfo" :mapListData="mapListData"></mapTop>
    <bottom></bottom>
  </div>
</template>
<script>
import centerTop from "./center-top.vue";
import mapTop from "./components/mapTop.vue";
import bottom from "./bottom.vue";
import { getPointLevelById } from "@/api/point.js";
import { extendBigScreenMapTj } from "@/api/daping.js";
export default {
  name: "index",
  components: {
    mapTop,
    bottom,
    centerTop
  },
  data() {
    return {
      pointInfo: {},
      mapListData: {}
    };
  },
  mounted() {
    this.getPointLevelByIdFun();
    this.extendBigScreenMapTj()
  },
  methods: {
    async getPointLevelByIdFun() {
      const res = await getPointLevelById({
        id: 1,
      });
      this.pointInfo = res.data.data;
      if (this.pointInfo.consultationHotline)
        this.pointInfo.phoneList = JSON.parse(this.pointInfo.consultationHotline)
          .map((item) => item.phone)
          .join("、");
    },
    async extendBigScreenMapTj() {
      let res = await extendBigScreenMapTj();
      if (res.data.code == 200) {
        this.mapListData = res.data.data;
      }
    },
  },
};
</script>
<style scoped lang="less">
.center-map {
  flex: 1;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/pages/patrolScreen/components/centerItem/index.vue